import { UseFormMethods } from 'react-hook-form';
import yup from 'src/libraries/validator.library';
import { REGEX_MILITARY_TIME } from 'src/constants';
import Lang from 'src/libraries/language';

export const AirDropsSchema = yup
  .object({
    dispatchId: yup.number().nullable(),
    recordId: yup.number().nullable(),
    dipCount: yup.number().nullable(),
    dropCount: yup.number().nullable(),
    waterLiters: yup.number().nullable(),
    waterGallons: yup.number().nullable(),
  })
  .defined();
const AirDropsSchemaRequired = yup
  .object({
    dispatchId: yup.number().nullable(),
    recordId: yup.number().nullable(),
    dipCount: yup.number().required().nullable(),
    dropCount: yup.number().required().nullable(),
    waterLiters: yup.number().required().nullable(),
    waterGallons: yup.number().required().nullable(),
  })
  .defined();

export const FireDispatchDetailsShape = yup
  .object()
  .shape({
    dispatchId: yup.number(),
    dispatchDate: yup.date().nullable(),
    dispatchTime: yup.string().nullable(),
    liftoffTime: yup.string().nullable(),
    responseTime: yup.string().nullable(),
    returnTime: yup.string().nullable(),
    flightHours: yup.string().nullable(),
    location: yup.string().nullable(),
    lattitude: yup.string().nullable(),
    longitude: yup.string().nullable(),
    helicopterCompany: yup.string().nullable(),
    tailNumber: yup.string().nullable(),
    pilot: yup.string().nullable(),
    coPilot: yup.string().nullable(),
    flightNumber: yup.string().nullable(),
    fuelCycles: yup.number().nullable(),
    landingCycles: yup.number().nullable(),
    billableLaunch: yup.string().nullable(),
    burnedAcres: yup.string().nullable(),
    fireAgency: yup.string().nullable(),
    fireName: yup.string().nullable(),
    fireComments: yup.string().nullable(),
    status: yup.string().nullable(),
    reason: yup.string().nullable(),
    FHRemainder: yup.string().nullable(),
    FHRemainderHrs: yup.string().nullable(),
    FHRemainderMins: yup.string().nullable(),
    GPSCoordinates: yup.string().nullable(),
    SDGEHrs: yup.string().nullable(),
    SDGEMins: yup.string().nullable(),
    agencyHrs: yup.string().nullable(),
    agencyMins: yup.string().nullable(),
    countyHrs: yup.string().nullable(),
    countyMins: yup.string().nullable(),
    dipCount: yup.string().nullable(),
    dropCount: yup.string().nullable(),
    entryDate: yup.string().nullable(),
    fireFundAgency: yup.string().nullable(),
    fireFundCounty: yup.string().nullable(),
    fireFundSDGE: yup.string().nullable(),
    flightHrs: yup.string().nullable(),
    flightMins: yup.string().nullable(),
    flightReason: yup.string().nullable(),
    lockFlag: yup.string().nullable(),
    operatorID: yup.number().nullable(),
    operatorName: yup.string().nullable(),
    reasonBy: yup.string().nullable(),
    reasonDate: yup.string().nullable(),
    updateDate: yup.string().nullable(),
    waterGallons: yup.string().nullable(),
    waterLiters: yup.string().nullable(),
    DispatchDrops: yup.array().of(AirDropsSchema).nullable(),
    enteredBy: yup.string().nullable(),
    updatedBy: yup.string().nullable(),
    dataSaved: yup.boolean().nullable(),
  })
  .defined();

const FireDispatchValidation = {
  dispatchId: yup.number().nullable(),
  dispatchDate: yup.date().nullable(),
  dispatchTime: yup
    .string()
    .nullable()
    .matches(REGEX_MILITARY_TIME, Lang.MSG_MILITARY_TIME_ERROR),
  liftoffTime: yup
    .string()
    .nullable()
    .matches(REGEX_MILITARY_TIME, Lang.MSG_MILITARY_TIME_ERROR),
  responseTime: yup.string().nullable(),
  returnTime: yup
    .string()
    .nullable()
    .matches(REGEX_MILITARY_TIME, Lang.MSG_MILITARY_TIME_ERROR),
  flightHours: yup.string().nullable(),
  flightReason: yup.string().nullable(),
  location: yup.string().nullable(),
  lattitude: yup.string().nullable(),
  longitude: yup.string().nullable(),
  operatorID: yup.number().nullable(),
  operatorName: yup.string().nullable(),
  tailNumber: yup.string().nullable(),
  pilot: yup.string().nullable(),
  coPilot: yup.string().nullable(),
  dipCount: yup.string().nullable(),
  dropCount: yup.string().nullable(),
  waterGallons: yup.string().nullable(),
  waterLiters: yup.string().nullable(),
  fuelCycles: yup.number().nullable(),
  landingCycles: yup.number().nullable(),
  fireName: yup.string().nullable(),
  fireComments: yup.string().nullable(),
  burnedAcres: yup.string().nullable(),
  billableLaunch: yup.string().nullable(),
  fireAgency: yup.string().nullable(),
  status: yup.string().nullable(),
  reason: yup.string().nullable(),
  enteredBy: yup.string().nullable(),
  updatedBy: yup.string().nullable(),
  flightNumber: yup.string().nullable(),
  DispatchDrops: yup.array().of(AirDropsSchema).nullable(),
  dataSaved: yup.boolean().nullable(),
};

export const FireDispatchShape = yup
  .object()
  .shape({
    ...FireDispatchValidation,
    dispatchDate: yup.date().required().nullable(),
    status: yup.string().required().nullable(),
  })
  .defined();

export const FireDispatchValidationShapes = (status) => {
  switch (status) {
    case Lang.LBL_FIRE_DISPATCH_STATUS_DISPATCHED:
      return yup
        .object()
        .shape({
          ...FireDispatchValidation,
          dispatchDate: yup.date().required().nullable(),
          status: yup.string().required().nullable(),
          dispatchTime: yup
            .string()
            .required()
            .nullable()
            .matches(REGEX_MILITARY_TIME, Lang.MSG_MILITARY_TIME_ERROR),
          tailNumber: yup.string().required().nullable(),
          location: yup.string().required().nullable(),
        })
        .defined();
    // break; /* Unreachable code detected */
    case Lang.LBL_FIRE_DISPATCH_STATUS_IN_FLIGHT:
      return yup
        .object()
        .shape({
          ...FireDispatchValidation,
          dispatchDate: yup.date().required().nullable(),
          status: yup.string().required().nullable(),
          dispatchTime: yup
            .string()
            .required()
            .nullable()
            .matches(REGEX_MILITARY_TIME, Lang.MSG_MILITARY_TIME_ERROR),
          location: yup.string().required().nullable(),
          tailNumber: yup.string().required().nullable(),
          fireAgency: yup.string().required().nullable(),
        })
        .defined();
    // break; /* Unreachable code detected */
    case Lang.LBL_FIRE_DISPATCH_STATUS_LANDED:
      return yup
        .object()
        .shape({
          ...FireDispatchValidation,
          dispatchDate: yup.date().required().nullable(),
          status: yup.string().required().nullable(),
          dispatchTime: yup
            .string()
            .required()
            .nullable()
            .matches(REGEX_MILITARY_TIME, Lang.MSG_MILITARY_TIME_ERROR),
          liftoffTime: yup
            .string()
            .required()
            .nullable()
            .matches(REGEX_MILITARY_TIME, Lang.MSG_MILITARY_TIME_ERROR),
          returnTime: yup
            .string()
            .required()
            .nullable()
            .matches(REGEX_MILITARY_TIME, Lang.MSG_MILITARY_TIME_ERROR),
          location: yup.string().required().nullable(),
          tailNumber: yup.string().required().nullable(),
          fireName: yup.string().required().nullable(),
          fireAgency: yup.string().required().nullable(),
        })
        .defined();
    // break; /* Unreachable code detected */
    case Lang.LBL_FIRE_DISPATCH_STATUS_COMPLETED:
      return yup
        .object()
        .shape({
          ...FireDispatchValidation,
          dispatchDate: yup.date().required().nullable(),
          status: yup.string().required().nullable(),
          dispatchTime: yup
            .string()
            .required()
            .nullable()
            .matches(REGEX_MILITARY_TIME, Lang.MSG_MILITARY_TIME_ERROR),
          liftoffTime: yup
            .string()
            .required()
            .nullable()
            .matches(REGEX_MILITARY_TIME, Lang.MSG_MILITARY_TIME_ERROR),
          returnTime: yup
            .string()
            .required()
            .nullable()
            .matches(REGEX_MILITARY_TIME, Lang.MSG_MILITARY_TIME_ERROR),
          flightHours: yup.string().required().nullable(),
          location: yup.string().required().nullable(),
          tailNumber: yup.string().required().nullable(),
          dipCount: yup
            .number()
            .positive()
            .typeError(Lang.MSG_ERROR_REQUIRED)
            .required(),
          dropCount: yup
            .number()
            .positive()
            .typeError(Lang.MSG_ERROR_REQUIRED)
            .required(),
          waterGallons: yup
            .number()
            .positive()
            .typeError(Lang.MSG_ERROR_REQUIRED)
            .required(),
          waterLiters: yup
            .number()
            .positive()
            .typeError(Lang.MSG_ERROR_REQUIRED)
            .required(),
          fireName: yup.string().required().nullable(),
          fireAgency: yup.string().required().nullable(),
          DispatchDrops: yup.array().of(AirDropsSchemaRequired).nullable(),
        })
        .defined();
    // break; /* Unreachable code detected */
    default:
      return FireDispatchShape;
  }
};

export const FireDispatchDetailsSchema = yup
  .object({
    fireDispatch: yup
      .object({
        counts: yup.object({
          all: yup.number(),
          dispatched: yup.number(),
          inFlight: yup.number(),
          landed: yup.number(),
          cancelled: yup.number(),
          completed: yup.number(),
        }),
        rows: yup.array().of(FireDispatchDetailsShape).defined(),
      })
      .defined(),
  })
  .defined();

export const FireDispatchSavedShchema = yup
  .object({
    drops: yup.array().of(AirDropsSchema).nullable(),
    fireDispatch: FireDispatchDetailsShape,
  })
  .defined();

export const FlightPilotSchema = yup
  .object({
    pilotId: yup.number(),
    name: yup.string(),
    phone: yup.string().nullable(),
  })
  .defined();

export const TailNumberSchema = yup
  .object({
    tailId: yup.number(),
    tailNumber: yup.string(),
  })
  .defined();

export const SettingsDataSchema = yup
  .object({
    fuelCycles: yup.number(),
    landingCycles: yup.number(),
  })
  .defined();

export const HelicopterCompanySchema = yup
  .object({
    Pilots: yup.array().of(FlightPilotSchema.clone()),
    operatorId: yup.number(),
    name: yup.string(),
    email: yup.string().nullable(),
    activeFlag: yup.boolean(),
    dispatchFlag: yup.boolean(),
    TailNumbers: yup.array().of(
      yup
        .object({
          tailNumber: yup.string(),
          tailId: yup.number(),
        })
        .defined()
    ),
  })
  .defined();

export const FireDispatchHelicopterCompanySchema = yup
  .object({
    operators: yup
      .object({
        count: yup.number(),
        rows: yup.array().of(HelicopterCompanySchema),
      })
      .defined(),
  })
  .defined();

export const SettingsSchema = yup
  .object({
    key: yup.string(),
    value: yup.string(),
    description: yup.string(),
    editFlag: yup.boolean(),
  })
  .defined();

export const AgencySchema = yup
  .object({
    agencyId: yup.number(),
    name: yup.string(),
    rate: yup.number(),
  })
  .defined();

export const FireAgencySchema = yup
  .object({
    fireAgencies: yup
      .object({
        count: yup.number(),
        rows: yup.array().of(AgencySchema),
      })
      .defined(),
  })
  .defined();

export type IFireDispatchDetails = yup.InferType<
  typeof FireDispatchDetailsShape
>;
export type IFireDispatch = yup.InferType<typeof FireDispatchShape>;
export type IFireDispatchReadDetails = yup.InferType<
  typeof FireDispatchDetailsSchema
>;
export type IHelicopterCompany = yup.InferType<typeof HelicopterCompanySchema>;
export type ITailNumber = yup.InferType<typeof TailNumberSchema>;
export type IFlightPilot = yup.InferType<typeof FlightPilotSchema>;
export type IAirDrops = yup.InferType<typeof AirDropsSchema>;
export type ISettings = yup.InferType<typeof SettingsSchema>;
export type ISettingsDataSchema = yup.InferType<typeof SettingsDataSchema>;
export type IAgency = yup.InferType<typeof AgencySchema>;
export type IFireAgency = yup.InferType<typeof FireAgencySchema>;
export type IFireDispatchHelicopterCompany = yup.InferType<
  typeof FireDispatchHelicopterCompanySchema
>;
export type INewFireDispatchMethods = Pick<
  UseFormMethods<IFireDispatchDetails>,
  'control' | 'errors'
>;
